import { observer } from 'mobx-react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './cleanByRoomTable.module.scss';

interface CleanByRoomData {
  [key: string]: string[];
}

interface TableRow {
  [key: string]: string;
}

interface BootleByRoomScreenProps {
  cleanbyRoomData: {}[];
  isLoading: boolean;
}

const CleanByRoomTable: React.FC<BootleByRoomScreenProps> = ({ cleanbyRoomData, isLoading }) => {
  const allKeys = Object.keys((cleanbyRoomData as unknown as CleanByRoomData) || {});
  const maxRows = Math.max(
    ...allKeys.map(key => (cleanbyRoomData as unknown as CleanByRoomData)[key]?.length || 0)
  );
  const tableData: TableRow[] = Array.from({ length: maxRows }).map((_, rowIdx) => {
    const row: TableRow = {};
    allKeys.forEach(key => {
      row[key] = (cleanbyRoomData as unknown as CleanByRoomData)[key]?.[rowIdx] ?? '-';
    });
    return row;
  });

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <ProgressSpinner className={classes.spinner} />
        <div>Loading clean by room data...</div>
      </div>
    );
  }

  return (
    <div className={classes.cleanByRoomContainer}>
      <div className={classes.cleanByRoomTableContainer}>
        <DataTable
          value={tableData}
          className={classes.dataTable}
          emptyMessage="No records found"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          scrollHeight="flex"
        >
          {allKeys.map(key => (
            <Column
              key={key}
              field={key}
              header={key}
              className={classes.column}
              style={{ minWidth: 20, maxWidth: 150, textAlign: 'left', paddingLeft: 10 }}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default observer(CleanByRoomTable);
